import {useMemo} from 'react'

export const useWeekdayShorts = (language?: string): string[] =>
  useMemo(() => {
    try {
      const formatter = new Intl.DateTimeFormat(language, {weekday: 'short'})
      const baseUtcSunday = Date.UTC(2021, 7, 1)
      return Array.from({length: 7}, (_, i) =>
        formatter.format(new Date(baseUtcSunday + i * 86400000)),
      )
    } catch {
      return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
    }
  }, [language])
